export const matchTaskStatusColors = (taskStatus) => {
    switch (String(taskStatus)) {
        case '1':
        case '11': // 退單驗證中（扣款狀態+10對稱）
            return 'warning';
        case '3':
        case '13': // 退單處理中
            return 'info';
        case '2':
        case '12': // 退單已驗證
            return 'success';
        case '4':
        case '14': // 退單完成
            return 'success-darken';
        case '7':
        case '17': // 退單驗證失敗
            return 'gray';
        case '8':
        case '9':
        case '18': // 退單處理失敗
        case '19': // 退單發生錯誤
            return 'error';
        default:
            return 'gray';
        // return 'warning';
    }
};

/**
 * @description 退單任務狀態值範圍（狀態值 11~19，對稱扣款狀態+10）
 * @type {number[]}
 */
export const RETURN_TASK_STATUS_VALUES = [11, 12, 13, 14, 17, 18, 19];

/**
 * @description 判斷任務狀態是否屬於退單任務
 * @param {number|string} taskStatus - 任務狀態
 * @returns {boolean} - 是否為退單任務狀態
 */
export const isReturnTaskStatus = (taskStatus) => RETURN_TASK_STATUS_VALUES.includes(Number(taskStatus));

/**
 * @description 匹配訂單狀態顏色
 * @param {number} orderStatus - 訂單狀態
 * @returns {string} - 訂單狀態顏色
 */ 

export const matchOrderStatusColors = (orderStatus) => {
    switch (String(orderStatus)) {
        case '1':
            return 'success';
        case '2':
            return 'warning';
        case '3':
            return 'gray';  
        default:
            return 'warning';

    }
};

/**
 * @description 匹配訂單付款狀態顏色
 * @param {number} orderPaymentStatus - 訂單付款狀態
 * @returns {string} - 訂單付款狀態顏色
 * 付款狀態 
 1 付款成功或免付款, 2 付款中, 3 未付款, 8 付款欠費, 9 付款異常
 */ 

export const matchOrderPaymentStatusColors = (orderPaymentStatus) => {
    switch (String(orderPaymentStatus)) {
    case '1': // 付款成功或免付款
        return 'success'; 
    case '2': // 付款中
        return 'info';
    case '3': // 未付款
        return 'grey'; 
    case '8': // 付款欠費
        return 'warning'; 
    case '9': // 付款異常
        return 'error'; 
    default:
        return 'grey';
    }
};